import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  TabPanel,
  Tab,
  Tabs,
  TABLE_LAYOUT_OPTIONS,
  Loader,
  SecondaryButton,
  SearchInput,
  IconFileDownload
} from 'cdk-radial';
import ActiveSubscriptionsTable from './activeSubscriptions/ActiveSubscriptionsTable'
import PendingSubscriptionsTable from './pendingSubscriptions/PendingSubscriptionsTable'
import UnsubscribedTable from './unsubscribed/UnsubscribedTable';
import './subscriptionManagementLandingPage.scss';
import Page from '../../page/index';
import { getSolutionSubscriptionInfo,
         getAuthorisationStatus }
    from '../../../redux/connectedComponent/subscriptionManagement/subscriptionManagement.slice';
import { clearSelectLocations } from '../../../redux/connectedComponent/selectedLocations/selectedLocations.slice';
import { clearDMS } from '../../../redux/connectedComponent/selectedDMS/selectedDMS.slice';
import {  clearUpdateDMSAccounts } from '../../../redux/connectedComponent/updateDMSAccounts/updateDMSAccounts.slice';
import { clearSolutionInfo } from '../../../redux/connectedComponent/solutionInfo/solutionInfo.slice';
import { clearPendingLocations } from '../../../redux/connectedComponent/subscriptionManagement/cancelSubscription.slice';
import { clearRemoveLocationsAdditionalData } from '../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import AuthComponent from '../../common/AuthComponent';
import Notification from '../../notification/Notification';
import { resetSubscriptionFlags } from '../../../redux/connectedComponent/completeSubscription/completeSubscription.slice';
import { setLocationsAsPerApp } from '../../../redux/connectedComponent/loginDetails/loginDetails.slice';
import {clearConsentDetails} from '../../../redux/connectedComponent/consentDetails/consentDetails.slice'
import { clearProvisioningSettings } from '../../../redux/connectedComponent/provisionSettings/provisionSettings.slice';
import { createCSVData } from './utils/utils';
import LearnMore from '../../LearnMore/LearnMore';
import BrowseMarketplaceButton from './BrowseMarketplaceButton';
import { sendAmplitudeData } from '../../../utils/amplitude';
import { AMPLITUDE_EVENTS } from '../../../constants/amplitudeConstants';
import { PAGE_TITLE } from '../../../constants/constants';
import { trackPageView, PAGE_SECTIONS, PAGE_SUBSECTIONS } from '../../../utils/gtm';

const ACTIVE = 'Active';
const PENDING = 'Pending';
const UNSUBSCRIBED = 'Unsubscribed/Deactivated';
const APP_MANAGEMENT = 'App Management';
const APP_MANAGEMENT_DESCRIPTION = 'Manage all your apps.';

const COLOR_STROKE = '#006CFA';
const LOADER_STYLE = {
    stroke: COLOR_STROKE,
    "margin-top" : '200px ',
    display: 'flex'
  };

const SEARCH_INPUT_STYLE = {
    width: '300px'
};
const PLACEHOLDER = 'Search by App Name or Publisher';
const CSV_FILE_NAME = 'App-Management-Report.csv';

function SubscriptionManagementLandingPage({solutionData, activateUnsubscription,subscriptionData,isBulkSubscribed}){

    const [activeItemIndex, setActiveItemIndex] = useState(0);
    const [activeTableLayout, setActiveTableLayout] = useState();
    const [checkActiveTablePagination, setCheckActiveTablePagination] = useState(true);
    const [pendingTableLayout, setPendingTableLayout] = useState();
    const [checkPendingTablePagination, setCheckPendingTablePagination] = useState(true);
    const [unsubscribedTableLayout, setUnsubscribedTableLayout] = useState();
    const [checkUnsubscribedTablePagination, setCheckUnsubscribedTablePagination] = useState(true);
    const [showSuccessMessage,setShowSuccessMessage]=useState(false);
    const [last4,setLast4]=useState('XXXX')
    const [loading, setLoading] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [csv, setCSV] = useState('');
    const [activeSubscriptions, setActiveSubscriptions] = useState([]);
    const [pendingSubscriptions, setPendingSubscriptions] = useState([]);
    const [unsubscribedSubscriptions, setUnsubscribedSubscriptions] = useState([]);

    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const token = state.loginDetailsSlice && state.loginDetailsSlice.authenticationToken;
    const { authorised, canPurchaseDisabled, canPurchaseEnabled,userEmail,authenticationToken } = state.loginDetailsSlice && state.loginDetailsSlice;
    const subscriptionCount = state.subscriptionManagementSlice.subscriptionCount;
    const fetchingSubscriptions = state.subscriptionManagementSlice.fetchingSubscriptions;
    const additionalData = state.uiFactorySlice.additionalData;
    const notificationContent = additionalData && additionalData.notificationContent;
    const notificationType = additionalData && additionalData.notificationType;
    const showNotification = additionalData && additionalData.showNotification;
    const verifyAccountSlice= state.verifyAccountSlice;
    const multiDepositSlice= state.multiDepositSlice;
    const successMessage=`The account ending ${last4} has been verified. Allow 1-2 business days for this subscription to become active.`
    const POSITIVE = 'positive';
    const pendingSubscriptionsData = state.subscriptionManagementSlice.pendingSubscriptions;
    const solutionSubscriptionInfo = state.subscriptionManagementSlice.solutionSubscriptionInfo;
    const allLocations = state.loginDetailsSlice.allLocations;
    const unsubscribedSolutionsData = state.subscriptionManagementSlice.unsubscribedSolutions;
    const inActiveBulkSubscriptionsData =  state.subscriptionManagementSlice.inActiveBulkSubscriptions;

    const mergeLocations = allLocationsWithDetails => {
        let mergedLocations = [];
        //merge cmfs for locations having same entityId
        let allEntityIds = allLocationsWithDetails && allLocationsWithDetails.map(location => location.entityId);
        allEntityIds = [...new Set(allEntityIds)];
        allEntityIds.map(entityId => {
            let matchingLocations = allLocationsWithDetails.filter(location => location.entityId === entityId);
            if (matchingLocations.length > 1) {
                let cmfs = matchingLocations.map(location => location.cmfNumber)
                let commonLocation = {
                    cmfNumber: cmfs,
                    entityId: matchingLocations[0].entityId,
                    partyName: matchingLocations[0].partyName,
                    canPurchase: matchingLocations[0].canPurchase,
                    bucode: matchingLocations[0].bucode,
                    orgId: matchingLocations[0].orgId,
                    name: matchingLocations[0].orgName,
                    status: matchingLocations[0].status
                };
                mergedLocations.push(commonLocation);
            }
            else {
                mergedLocations.push(matchingLocations[0]);
            }
        })
        return mergedLocations;
      }

      const handleDownload = (e) => {
        e.stopPropagation();
        sendAmplitudeData(AMPLITUDE_EVENTS.DOWNLOAD_APP_MANAGEMENT_REPORT, {});
        var link = document.createElement('a');
        link.href = csv;
        link.download = CSV_FILE_NAME;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

    useEffect(()=>{
        dispatch(clearSolutionInfo());
        const locations = mergeLocations([...canPurchaseDisabled, ...canPurchaseEnabled]);
        const entityIds = locations.map(item => item.entityId);
        dispatch(setLocationsAsPerApp({unAuthTitleEnabled: true}))
        dispatch(getSolutionSubscriptionInfo({entityIds,token}))
        dispatch(clearSelectLocations());
        dispatch(clearDMS());
        dispatch(clearUpdateDMSAccounts());
        dispatch(clearPendingLocations());
        dispatch(resetSubscriptionFlags());
        dispatch(clearConsentDetails());
        dispatch(clearProvisioningSettings());
    },[]);

    useEffect(() => {
        const { solnId, last4 } = multiDepositSlice
        if (verifyAccountSlice) {
            const filteredArray = verifyAccountSlice[solnId]
            if (filteredArray && filteredArray.status !== null) {
                const locations = [...canPurchaseDisabled, ...canPurchaseEnabled]
                const entityIds = locations.map(item => item.entityId);
                setLast4(last4);
                setShowSuccessMessage(true)
                dispatch(getSolutionSubscriptionInfo({ entityIds, token }))
            }
        }
    }, [multiDepositSlice])

    useEffect(() => {
        const canPurchaseOn = canPurchaseEnabled.length && canPurchaseEnabled.map(item => item.entityId);
        dispatch(getAuthorisationStatus({ canPurchaseOn: canPurchaseOn || [], authorised: authorised }))
    }, [canPurchaseEnabled, authorised])

    useEffect(() => {
        if (subscriptionCount.active > 10) {
            setCheckActiveTablePagination(true);
            setActiveTableLayout(TABLE_LAYOUT_OPTIONS.NORMAL);
        } else {
            setCheckActiveTablePagination(false);
            setActiveTableLayout(TABLE_LAYOUT_OPTIONS.AUTO_HEIGHT);
        }
    }, [subscriptionCount.active]);

    useEffect(() => {
        if (subscriptionCount.pending > 10) {
            setCheckPendingTablePagination(true);
            setPendingTableLayout(TABLE_LAYOUT_OPTIONS.NORMAL);
        } else {
            setCheckPendingTablePagination(false);
            setPendingTableLayout(TABLE_LAYOUT_OPTIONS.AUTO_HEIGHT);
        }
    }, [subscriptionCount.pending]);

    useEffect(() => {
        if (subscriptionCount.unsubscribed > 10) {
            setCheckUnsubscribedTablePagination(true);
            setUnsubscribedTableLayout(TABLE_LAYOUT_OPTIONS.NORMAL);
        } else {
            setCheckUnsubscribedTablePagination(false);
            setUnsubscribedTableLayout(TABLE_LAYOUT_OPTIONS.AUTO_HEIGHT);
        }
    }, [subscriptionCount.unsubscribed]);

    useEffect(() => {
        if (fetchingSubscriptions) {
            setLoading(true);
        } else {
            setLoading(false)
            dispatch(clearSolutionInfo());
        }
    }, [fetchingSubscriptions]);

    useEffect(() => {
        let activeSubscriptionContent = activeSubscriptions?.map(e => e?.join(","))?.join("\n");
        let pendingSubscriptionContent = pendingSubscriptions?.map(e => e?.join(","))?.join("\n");
        let unsubscribedSubscriptionContent = unsubscribedSubscriptions?.map(e => e?.join(","))?.join("\n");
        let csvContent = "data:text/csv;charset=utf-8," + activeSubscriptionContent + pendingSubscriptionContent + unsubscribedSubscriptionContent;
        setCSV(encodeURI(csvContent));
    }, [activeSubscriptions, pendingSubscriptions, unsubscribedSubscriptions]);

    useEffect(() => {
        if (pendingSubscriptionsData) {
            let subscriptionData = createCSVData(pendingSubscriptionsData, {}, solutionSubscriptionInfo, allLocations, PENDING);
            setPendingSubscriptions(subscriptionData);
        }
    }, [pendingSubscriptionsData, solutionSubscriptionInfo]);

    useEffect(() => {
        if (unsubscribedSolutionsData || inActiveBulkSubscriptionsData) {
            let subscriptionData = createCSVData(unsubscribedSolutionsData, inActiveBulkSubscriptionsData, solutionSubscriptionInfo, allLocations, UNSUBSCRIBED);
            setUnsubscribedSubscriptions(subscriptionData);
        }
    }, [unsubscribedSolutionsData, inActiveBulkSubscriptionsData, solutionSubscriptionInfo]);

    useEffect(() => {
        // Only track once data is loaded and not loading anymore
        if (!fetchingSubscriptions && subscriptionCount) {
            trackPageView({ page_section: PAGE_SECTIONS.APP_MANAGEMENT, page_subsection: PAGE_SUBSECTIONS.OVERVIEW });
        }
    }, [fetchingSubscriptions, subscriptionCount]);

    return (
        <Page pageHeader={PAGE_TITLE.APP_MANAGEMENT}>
            <div className="screen-size-subscription-mgmt">
                <div className="subscription-mgmt__container">
                    <div className="subscription-mgmt__heading">
                        <div className="subscription-mgmt__heading-title">{APP_MANAGEMENT}</div>
                        <div className="subscription-mgmt__browse">
                            <BrowseMarketplaceButton />
                        </div>
                        <div className="subscription-mgmt__heading-subtitle">
                            {APP_MANAGEMENT_DESCRIPTION}
                            {' '}
                            <LearnMore
                                docPath="/docs/marketplace/marketplace-for-apps/managing-app-configurations/"
                                screen="Managing App Configurations"
                            />
                        </div>
                    </div>
                    <SearchInput
                        placeholder={PLACEHOLDER}
                        isAlwaysExpanded
                        style={SEARCH_INPUT_STYLE}
                        onChange={input => setSearchInput(input)}
                        value={searchInput}
                    />
                    <div className='tab-component-container'>
                        <Tabs
                            activeItemIndex={activeItemIndex}
                            items={[
                                {
                                    id: 'tab-1',
                                    panelId: 'panel-1',
                                    renderPanel: (props) => (
                                        <TabPanel {...props}>
                                            {
                                                loading ?
                                                    <div className='subscription-mgmt__loader'>
                                                        <Loader style={LOADER_STYLE} label="Fetching Apps..." />
                                                    </div>
                                                    :
                                                    <ActiveSubscriptionsTable
                                                        solutionData={solutionData}
                                                        activateUnsubscription={activateUnsubscription}
                                                        subscriptionData={subscriptionData}
                                                        isBulkSubscribed={isBulkSubscribed}
                                                        activeCount={subscriptionCount.active}
                                                        activeTableLayout={activeTableLayout}
                                                        checkActiveTablePagination={checkActiveTablePagination}
                                                        searchInput={searchInput}
                                                        createCSV={activeSubscriptions => {
                                                            setActiveSubscriptions(activeSubscriptions);
                                                        }}
                                                    />
                                            }

                                        </TabPanel>
                                    ),
                                    renderTab: (props) => (
                                        <Tab label={`${ACTIVE} (${subscriptionCount.active})`} hideLabel={false} {...props}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                sendAmplitudeData(AMPLITUDE_EVENTS.VIEW_ACTIVE_SUBSCRIPTIONS, {})
                                                setActiveItemIndex(0)
                                            }} />
                                    ),
                                },
                                {
                                    id: 'tab-2',
                                    panelId: 'panel-2',
                                    renderPanel: (props) => (
                                        <TabPanel {...props}>
                                            {
                                                loading ?
                                                    <div className='subscription-mgmt__loader'>
                                                        <Loader style={LOADER_STYLE} label="Fetching Apps..." />
                                                    </div>
                                                    :
                                                    <PendingSubscriptionsTable
                                                        pendingTableLayout={pendingTableLayout}
                                                        checkPendingTablePagination={checkPendingTablePagination}
                                                        searchInput={searchInput}
                                                    />
                                            }

                                        </TabPanel>
                                    ),
                                    renderTab: (props) => (
                                        <Tab label={`${PENDING} (${subscriptionCount.pending})`} hideLabel={false} {...props}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                sendAmplitudeData(AMPLITUDE_EVENTS.VIEW_PENDING_SUBSCRIPTIONS, {})
                                                setActiveItemIndex(1)
                                            }} />
                                    ),
                                },
                                {
                                    id: 'tab-3',
                                    panelId: 'panel-3',
                                    renderPanel: (props) => (
                                        <TabPanel {...props}>
                                            {
                                                loading ?
                                                    <div className='subscription-mgmt__loader'>
                                                        <Loader style={LOADER_STYLE} label="Fetching Apps..." />
                                                    </div>
                                                    :
                                                    <UnsubscribedTable
                                                        unsubscribedTableLayout={unsubscribedTableLayout}
                                                        checkUnsubscribedTablePagination={checkUnsubscribedTablePagination}
                                                        searchInput={searchInput}
                                                    />
                                            }
                                        </TabPanel>
                                    ),
                                    renderTab: (props) => (
                                        <Tab label={`${UNSUBSCRIBED} (${subscriptionCount.unsubscribed})`} hideLabel={false}  {...props}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                sendAmplitudeData(AMPLITUDE_EVENTS.VIEW_INACTIVE_SUBSCRIPTIONS, {})
                                                setActiveItemIndex(2)
                                            }} />
                                    ),
                                }
                            ]}
                            onActiveItemChange={setActiveItemIndex}
                        />
                        {
                            !loading &&
                            <div className='download-report-container'>
                                <SecondaryButton
                                    text="App Management Report"
                                    onClick={(event) => handleDownload(event)}
                                    icon={<IconFileDownload />}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
            {showNotification &&
                <Notification
                    content={notificationContent}
                    variant={notificationType}
                    actions={[{ "text": "Dismiss" }]}
                    onDismiss={() => { dispatch(clearRemoveLocationsAdditionalData()) }}
                    customStyle={{ marginTop: '70px' }}
                />
            }
            {showSuccessMessage &&
                <Notification
                    content={successMessage}
                    variant={POSITIVE}
                    actions={[{ "text": "Dismiss" }]}
                    onDismiss={() => { setShowSuccessMessage(false) }}
                    customStyle={{ marginTop: '50px' }}
                />

            }

        </Page>
    );
};

export default withRouter(AuthComponent(SubscriptionManagementLandingPage));
